module.exports = __webpack_public_path__ + "img/CG1_18.6724dfb.png";